import React, { useEffect, useMemo, useRef, useState } from "react";
import OrderSummary from "../components/Orders/OrderSummary";
import OrderService from "../services/orders.service";
import { useNavigate, useParams } from "react-router";
import { Order } from "../entities/interfaces/order";
import ClientInfo from "../components/Orders/ClientInfo";
import { Button, Col, Divider, Popconfirm, Radio, Row, Tag } from "antd";
import useOrder from "../hooks/useOrder";
import { PaymentMode } from "../entities/dto/order.dto";
import { useReactToPrint } from "react-to-print";
import BillLayout from "../components/Orders/BillLayout";
import { useStore } from "../context/StoreContext";
import BillModal from "../components/Orders/BillModal";
import OrderItemList from "../components/Orders/OrderItemList";
import { flattenOrderItems } from "../utils/orderhelpers";
import BackButton from "../components/misc/BackButton";
import toast from "react-hot-toast";
import WithPermission from "../components/misc/WithPermission";

const OrderDetails = () => {
  const { loading, paymentMode, updateField, retryPayment, makeManualPayment } =
    useOrder();
  const [order, setOrder] = useState<any>();
  const { id } = useParams();
  const { selectedStore } = useStore();
  const [billPrint, setBillPrint] = useState(false);
  const navigate = useNavigate();

  const orderItemList = useMemo(
    () => flattenOrderItems(order?.items || []),
    [order]
  );

  useEffect(() => {
    getOrder();
  }, []);

  const getOrder = async () => {
    if (!id) return;
    const res = await OrderService.get(id);
    if (res.success) {
      setOrder(res.data);
      updateField("bill", res.data.bill);
      updateField("paymentMode", res.data.bill?.paymentMode as PaymentMode);
    }
  };

  const deleteOrder = async () => {
    if (!id) return;
    const res = await OrderService.delete(id);
    if (res.success) {
      navigate("/orders");
      toast.success("Order deleted successfully");
    }
  };

  if (!order) return <></>;

  return (
    <Row gutter={40}>
      <BillModal open={billPrint} onClose={() => setBillPrint(!billPrint)}>
        <>
          {selectedStore ? (
            <BillLayout store={selectedStore} order={order} />
          ) : (
            "Select a store"
          )}
        </>
      </BillModal>
      <Col
        span={16}
        className="col-span-7 flex flex-col px-8"
        style={{ height: "calc(100vh - 150px)" }}
      >
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2 ">
            <BackButton />
            <h1 className="text-lg font-semibold">Order - {order.orderId} </h1>
            {order.paid ? (
              <Tag color="green">PAID</Tag>
            ) : (
              <Tag color="red">PENDING</Tag>
            )}
          </div>
          <WithPermission permission="delete:order">
            <Popconfirm
              title="Delete this order"
              description="Are you sure to delete this order"
              onConfirm={deleteOrder}
              okText="Yes"
              cancelText="No"
            >
              <Button size="small" danger className="justify-self-end">
                Delete
              </Button>{" "}
            </Popconfirm>
          </WithPermission>
        </div>
        <Divider />
        <ClientInfo client={order.customer} />
        <Divider />
        <h1 className="text-lg font-semibold mb-5">Order items</h1>
        <div>
          <OrderItemList flatOrderItems={orderItemList} />
        </div>
      </Col>
      <Col span={8}>
        {order.bill ? (
          <>
            <OrderSummary
              subtotal={order?.bill.subtotal || 0}
              tax={order?.bill.tax || 0}
              total={order?.bill.totalAmount || 0}
              items={order?.items || []}
              //   membershipDiscount={amount.membershipDiscount}
            />
            {/* <Divider /> */}
            {order?.bill?.paid ? (
              <Button
                size="large"
                className="w-full mt-5"
                variant="solid"
                color="blue"
                onClick={() => setBillPrint(true)}
              >
                Print Bill Copy
              </Button>
            ) : (
              <>
                <Radio.Group
                  block
                  // disabled={freezeService}
                  className="mt-4"
                  options={[
                    { label: "Cash", value: "CASH" },
                    { label: "Card", value: "CARD" },
                    { label: "UPI", value: "UPI" },
                  ]}
                  optionType="button"
                  buttonStyle="solid"
                  value={paymentMode}
                  onChange={(e) => updateField("paymentMode", e.target.value)}
                />
                {/* <Button
                  size="large"
                  variant="solid"
                  color="red"
                  className="w-full"
                  onClick={retryPayment}
                  disabled={loading}
                  loading={loading}
                >
                  Retry Payment
                </Button> */}
                <Divider />
                <Button
                  size="large"
                  className="w-full"
                  variant="solid"
                  color="green"
                  onClick={async () => {
                    await makeManualPayment();
                    setBillPrint(true);
                    await getOrder();
                  }}
                >
                  Manual Payment & Print
                </Button>
              </>
            )}
          </>
        ) : (
          <div>Bill not generated</div>
        )}
      </Col>
    </Row>
  );
};

export default OrderDetails;
